import { Box } from '@missionlabs/smartagent-app-components';
import React from 'react';
import Main from './components/Main/Main';

const App: React.FC = () => {
    const isEmbedded = window.parent !== window;

    return (
        <>
            {isEmbedded ? (
                <Main />
            ) : (
                <Box header="Contract Details" alt>
                    <Main />
                </Box>
            )}
        </>
    );
};

export default App;
